import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/recyclingMaterials/importer/recyclingMaterialsImporterActions';

export default importerReducers(actions);
